import { createApiClient } from './client.js';

export const UNAUTH_EVENT = 'bs:unauthenticated';
const CSRF_KEY = 'bs.csrf';

export const api = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL ?? '',
  onUnauthenticated: () => window.dispatchEvent(new Event(UNAUTH_EVENT)),
});

// The CSRF token is not a secret from this tab (the session cookie is httpOnly); keeping it per-tab
// lets a reload keep working. Storage can be unavailable (private mode) — then a reload needs re-login.
try {
  const t = sessionStorage.getItem(CSRF_KEY);
  if (t) api.setCsrfToken(t);
} catch (e) {
  console.warn('sessionStorage unavailable; CSRF token will not survive reload', e);
}

export function rememberCsrf(t: string | null): void {
  api.setCsrfToken(t);
  try {
    if (t) sessionStorage.setItem(CSRF_KEY, t);
    else sessionStorage.removeItem(CSRF_KEY);
  } catch (e) {
    console.warn('sessionStorage unavailable', e);
  }
}
